import * as $ from 'jquery';

/**
 * Checks if an element is in the viewport of the container.
 * @param container The container.
 * @param element The element to check.
 * @param partial If true, check if the element is partially in the viewport. Otherwise check wholy.
 * @returns true if the element is in the container's viewport, otherwise false.
 */
export const checkIsInViewPort = (container: HTMLElement, element: HTMLElement, partial: boolean): boolean => {
  const $container = $(element);
  const contHeight = $container.width();

  const elemTop = $(element).offset().left - $container.offset().left;
  const elemBottom = elemTop + $(element).width();

  const isTotal = elemTop >= 0 && elemBottom <= contHeight;
  const isPart =
    ((elemTop < 0 && elemBottom > 0) ||
      (elemTop > 0 && elemTop <= $container.width())) &&
    partial;

  return isTotal || isPart;
};
